import React from 'react';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { CREDIT_REPAIR_EXPERT_ACTION_TIP } from 'types/morph.pagePosition.constants';
import { useSeenModulePixel, useViewModule } from 'hook/helper.hook';
import CreditRepairExpertTipView from './CreditRepairExpertTipView';
import { CREDIT_REPAIR_VERTICAL } from 'types/mrph.vertical.constants';
import { useCreditRepairExpertTipHook } from './hooks/CreditRepairExpertTip.hook';

const CreditRepairExpertTipController = props => {
  const { extraAttributes, eventHandler } = props;
  const { onClickCall } = useCreditRepairExpertTipHook(eventHandler);
  const atr = getViewModuleTrackingAttributes({
    pagePosition: CREDIT_REPAIR_EXPERT_ACTION_TIP,
    modulePosition: extraAttributes.modulePosition,
    vertical: CREDIT_REPAIR_VERTICAL,
  });

  useViewModule(atr);
  const seenPixel = useSeenModulePixel(atr);
  return (
    <CreditRepairExpertTipView
      seenPixel={seenPixel}
      {...props}
      onClickCall={onClickCall}
    />
  );
};

export default CreditRepairExpertTipController;
